import React, { useState, useEffect } from 'react';
import PhaserGame from './PhaserGame';
import './App.css';

function App() {
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (!online) {
    return (
      <div className="App offline-screen">
        <div className="offline-card">
          <div className="offline-icon">📡</div>
          <h1>No Internet Connection</h1>
          <p>Animal Stack requires an internet connection to play.</p>
          <p className="offline-hint">Please check your Wi-Fi or mobile data and try again.</p>
          <button className="offline-btn" onClick={() => setOnline(navigator.onLine)}>
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <PhaserGame />
    </div>
  );
}

export default App;
